import React from "react";

import { Link } from "react-router-dom";
import { encodeId } from "../../../utils/common";
import { useSelector } from "react-redux";

import { FaTrashAlt } from "react-icons/fa";
import Add_to_card_btn from "../../common-components/common_btn/Add_to_card_btn/Add_to_card_btn";
import Green_btn from "../../common-components/common_btn/green_btn/Green_btn";

const Product_Info_Table = ({
  product,
  imgSrc,
  productName,
  priceText,
  quantity = "100 ML",
  addedDate = "27-10-2026",
  onDelete,
  activeVariant,
  isVendor,
}) => {
  const currentCurrency = useSelector((state) => state.master.currentCurrency);

  const rate = Number(currentCurrency?.rate) || 1;
  const symbol = currentCurrency?.symbol || "₹";

  return (
    <tr>
      <td>
        <div className="product_info_wrapper">
          <button
            className="delete_btn"
            onClick={() => onDelete?.(product?.id)}
          >
            <FaTrashAlt />
          </button>

          <Link
            to={`/product-details/${encodeId(product?.id)}`}
            className="product_link"
          >
            <div className="product_img_box">
              <img src={imgSrc} alt={productName} />
            </div>
          </Link>

          <div className="product_content">
            <Link
              to={`/product-details/${encodeId(product?.id)}`}
              className="product_name"
            >
              {productName}
            </Link>

            {/* <p className="quantity_text">Quantity</p>

            <span className="quantity_badge">{quantity}</span> */}
          </div>
        </div>
      </td>

      <td>
        <p className="date_text">{addedDate}</p>
      </td>

      <td>
        <p className="price_text">
          {symbol}
          {Number(priceText * rate).toFixed(2)}
        </p>
      </td>

      <td>
        <div className="cart_btn_wrapper">
          <Add_to_card_btn
            id={product?.id}
            product={product}
            btnText="Add to Cart"
            quantity={isVendor ? activeVariant?.b2b_min_quanity : 1}
          />
          {/* <Green_btn btnText={"Add to Cart"} /> */}
        </div>
      </td>
    </tr>
  );
};

export default Product_Info_Table;
